import React, { useEffect, useState, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Accordion, Card, Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import Library from "./Library";
import axios from "axios";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import HeaderScreen from "./HeaderScreen";
import CustomToggle from "./CustomToggle";
import ChatContext from "./ChatContext";
import chatIcon from "../../images/comment.svg";
import libraryIcon from "../../images/folder.svg";
import user from "../../images/userMes.svg";
import bot from "../../images/botMes.svg";
import plus from "../../images/plus.svg";
import mic from "../../images/mic.svg";
import upload from "../../images/upload.svg";
import file from "../../images/file.svg";
import url from "../../images/Page-1.svg";
import send from "../../images/paper-plane.svg";
import "./ChatScreen.scss";
import bell from "../../images/notification.svg";
import users from "../../images/userMes.svg";
import chatnew from "../../images/edit.svg";
import "./HeaderScreen.scss";
const Loading = () => {
  return (
    <div className="loader">
      <div className="dot red"></div>
      <div className="dot green"></div>
      <div className="dot blue"></div>
    </div>
  );
};

const ChatScreen = () => {
  const initialScale = 40;
  const { initialMessage } = useContext(ChatContext);
  const hasFetchedInitialMessage = useRef(false);
  const chatMessagesRef = useRef(null);
  const [message, setMessage] = useState("");
  const [showPdfPopup, setShowPdfPopup] = useState(false);

  const [activeTab, setActiveTab] = useState("chat");
  const [activeTab1, setActiveTab1] = useState("Files");
  const [chatMessages, setChatMessages] = useState([]);
  const [recommendedQuestions, setRecommendedQuestions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [showModal1, setShowModal1] = useState(false);
  const [modalImage1, setModalImage1] = useState(null);
  // const [pdfData, setPdfData] = useState("");
  const [pdfData1, setPdfData1] = useState(null);
  const [pdfData, setPdfData] = useState("");

  const [image, setImage] = useState("");
  const [previousQuestion, setPreviousQuestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileuploading, setfileuploading] = useState(false);
  const [fileuploaded, setfileuploaded] = useState(false);

  const newPlugin = defaultLayoutPlugin();
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [list, setlist] = useState({});
  const [libraryloading, setlibraryloader] = useState(true);

  const location = useLocation();
  const [isSearch, setIsSearch] = useState(true);
  const [tag, setTag] = useState("pdf");

  useEffect(() => {
    setTag(isSearch ? "pdf" : "url");
  }, [isSearch]);

  const handleToggle = () => {
    setIsSearch((prevIsSearch) => !prevIsSearch);
  };

  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const handleUpload = async (selectedFiles_var) => {
    if (selectedFiles_var) {
      try {
        const formData = new FormData();
        selectedFiles_var.forEach((file, index) => {
          console.log(index);
          formData.append(`file`, file);
        });
        console.log(selectedFiles_var);
        setfileuploading(true);
        const response = await axios.post(
          "https://industrygenai.accenture.com/tradingbe/uploadFiles",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("API response:", response.data);
        // const upload_response = response.data;
        // seUploadresponse(upload_response);
        setfileuploading(false);
        if (response.data === "file loaded successfully") {
          console.log("File uploaded successfully!");
          setfileuploaded(true);
          setTimeout(() => {
            setfileuploaded(false);
          }, 2000);
        } else {
          console.error("File upload failed.");
          alert("File upload failed.");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please select a file to upload.");
    }
  };
  const handleSendMessage1 = () => {
    if (message.trim() !== "") {
      handleSendMessage(message);
      setMessage("");
    }
  };
  const handleQuestionSelect = (question) => {
    // Set the selected question and send it as the next message

    setMessage(question);
    handleSendMessage1();
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setModalImage(null);
  };
  const handleCloseModal1 = () => {
    setShowModal1(false);
    setModalImage1(null);
  };
  const handleShowModal = (image) => {
    setModalImage(image);
    setShowModal(true);
  };
  const handleShowModal1 = (image) => {
    setModalImage1(image);
    setShowModal1(true);
  };

  const handleFileChange = async (e) => {
    const selectedFiles_var = Array.from(e.target.files);
    setSelectedFiles(selectedFiles_var);
    await handleUpload(selectedFiles_var);
    // setfileuploaded(true);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    paste = paste.trim();
    setMessage(paste);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && message.trim() !== "") {
      event.preventDefault(); // Prevent default behavior (new line)
      handleSendButtonClick();
    }
  };

  const handleSendButtonClick = () => {
    if (message.trim() !== "") {
      //navigate('/chat', { state: { message } });
      handleSendMessage(message);
      setMessage("");
    }
  };

  function formatMessage(message) {
    const lines = message?.split("\n");
    return (
      <div className="formatted-message">
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    );
  }

  const handleButtonClick1 = async (path) => {
    try {
      await fetch("https://industrygenai.accenture.com/tradingbe/get-pdf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ filepath: path }),
      })
        .then((res) => res.blob())
        .then((blob) => {
          const reader = new FileReader();
          console.log(
            "qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq",
            showPdfPopup
          );
          reader.onload = () => {
            setPdfData1(reader.result);
            setLoading(false);
          };
          console.log(reader.result);
          reader.readAsDataURL(blob);
          setShowPdfPopup(true);
        });
    } catch (error) {
      console.error("Error loading PDF:", error);
    }
  };

  const handleClose = () => {
    setShowPdfPopup(false);
  };

  const handleSendMessage = async (message) => {
    setChatMessages((prevMessages) => [
      ...prevMessages,
      { user: true, message, recommendation: false, init: true },
    ]);

    // Show loading spinner
    setLoading(true);
    try {
      //setShowLoader(true);

      // Create JSON payload for API request
      const json = { message, tag };
      console.log("tag", tag);

      // Send message to chatbot API
      const response = await axios.post("https://industrygenai.accenture.com/tradingbe/chatBot", json);

      console.log("Chatbot API response:", response.data);

      // Parse chatbot response
      const chatbotResponse =
        response.data.response === null
          ? "Unable to answer your query. Please try again.."
          : response.data.response;

      console.log("Chatbot response:", chatbotResponse);

      // Extract PDF data from response
      const pdfData = chatbotResponse;
      console.log("PDF Data:", pdfData.source);

      setPdfData(pdfData);
      setRecommendedQuestions(response.data.folderQuest);
      console.log("Folder Questions:", response.data.folderQuest);

      pdfData.source.forEach((pdf) => console.log("PDF Source:", pdf));

      // Add chatbot message to chat
      const botMessage = {
        user: false,
        message: chatbotResponse["answer"],
        source: chatbotResponse["source"],
        image: response.data.image,
        table: response.data.table,
        recommendedQuestions: response.data.folderQuest,
        pdfData: pdfData,
      };

      setChatMessages((prevMessages) => [...prevMessages, botMessage]);

      // Update additional states
      //setShowLoader(false);
      setImage(response.data.image);
      setPreviousQuestion(message);
      //setShowRegenerateButton(true);

      // console.log("Show Regenerate Button:", showRegenerateButton);
    } catch (error) {
      console.error(error);

      // Handle error by adding error message to chat
      const botMessage = {
        user: false,
        message: "Failed to Get the response.",
        recommendation: false,
        init: true,
      };

      setChatMessages((prevMessages) => [...prevMessages, botMessage]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialMessage && !hasFetchedInitialMessage.current) {
      console.log("Received message:", initialMessage);
      handleSendMessage(initialMessage);
      hasFetchedInitialMessage.current = true; // Mark that the initial API call has been made
    }
  }, [initialMessage]);

  useEffect(() => {
    // Scroll to bottom when chatMessages or recommendedQuestions change
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [chatMessages]);
  const handletabclick = async (type) => {
    var endpoint = "";
    setlibraryloader(true);

    setActiveTab(type);
    endpoint = "https://industrygenai.accenture.com/tradingbe/fileslist";

    const response = await axios.get(endpoint);
    console.log("******response response", response.data);

    const parsedObject =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;

    const result = parsedObject.response.filelist;

    console.log(result);
    setlibraryloader(false);
    setlist(result);
  };
  return (
    <div>
      {/* <HeaderScreen /> */}
      <div className="header-screen">
        <div className="row">
          <div className="col-sm-10">
            {location.pathname === "/chat" && (
              <div className="new-chat">
                <img src={chatnew} alt="New Chat" className="header-icon" />
                <div className="new-chat-text">New Chat</div>
              </div>
            )}
          </div>
          <div className="col-sm-2">
            {location.pathname === "/chat" && (
              <div className="toggle-section">
                <span className="toggle-label">Search URL:</span>
                <button
                  className="toggle-switch"
                  onClick={handleToggle}
                  style={{
                    marginRight: "10px",
                    backgroundColor: "grey",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    width: "40px",
                    height: "20px",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      position: "absolute",
                      top: "1px",
                      left: isSearch ? "1px" : "21px",
                      transition: "left 0.3s",
                    }}
                  />
                </button>
              </div>
            )}
            <img src={bell} alt="Bell" className="header-icon" />
            <img src={users} alt="User" className="header-icon" />
          </div>
        </div>
      </div>
      <div className="chat-screen">
        <div className="tab-container">
          <div
            className={`tab ${activeTab === "chat" ? "active" : ""}`}
            onClick={() => setActiveTab("chat")}
          >
            <img src={chatIcon} alt="Chat Icon" className="tab-icon" />
            Chat
          </div>
          <div
            className={`tab ${activeTab === "library" ? "active" : ""}`}
            onClick={() => handletabclick("library")}
          >
            <img
              src={libraryIcon}
              alt="Library Icon"
              className="tab-icon library-icon"
            />
            Library
          </div>
        </div>
        {activeTab === "chat" ? (
          <div style={{ width: "100%" }}>
            {/* {loading ? (
              <Loading />
            ) : ( */}
            <div className="chat-messages" ref={chatMessagesRef}>
              {chatMessages?.map((message, index) => (
                <div
                  key={index}
                  className={`message-row ${
                    message.user ? "user-message" : "bot-message"
                  }`}
                >
                  <div className="message-content">
                    <div className="message-info">
                      <img
                        src={message.user ? user : bot}
                        alt="Avatar"
                        className="avatar"
                      />
                      <div className="sender-name">
                        <span>{message.user ? "You" : "Chatbot"}</span>
                        <div className="message-text">
                          {formatMessage(message.message)}
                        </div>
                      </div>
                    </div>
                  </div>

                  {!message.user && (
                    <div className="message-meta">
                      <div className="accordions">
                        {message.image && (
                          <Accordion className="meta-accordion">
                            <Accordion.Item eventKey="0">
                              <Accordion.Header>
                                <div className="accordion-title">Image</div>
                                <div className="accordion-count">
                                  1{/* Display the count */}
                                </div>
                                <CustomToggle eventKey="0" />
                              </Accordion.Header>
                              <Accordion.Body className="custom-accordion-body">
                                <Button
                                  className="expand-button"
                                  onClick={() => handleShowModal(message.image)}
                                >
                                  {/* <FontAwesomeIcon icon={faExpand} /> */}
                                  <img
                                    src={plus}
                                    alt="Expand"
                                    style={{ width: "20px", height: "20px" }} // Adjust size as needed
                                  />
                                </Button>
                                <Card.Img src={message.image} alt="Image" />
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        )}
                        {message.table && (
                          <Accordion className="meta-accordion">
                            <Accordion.Item eventKey="0">
                              <Accordion.Header>
                                <div className="accordion-title">Table</div>
                                <div className="accordion-count">
                                  {message?.table?.length ? "1" : " "}
                                  {/* Display the count */}
                                </div>
                                <CustomToggle eventKey="0" />
                              </Accordion.Header>
                              <Accordion.Body className="custom-accordion-body">
                                <Button
                                  className="expand-button"
                                  onClick={() =>
                                    handleShowModal1(message.table)
                                  }
                                >
                                  {/* <FontAwesomeIcon icon={faExpand} /> */}
                                  <img
                                    src={plus}
                                    alt="Expand"
                                    style={{ width: "20px", height: "20px" }} // Adjust size as needed
                                  />
                                </Button>

                                <div
                                  className="tableStyle"
                                  dangerouslySetInnerHTML={{
                                    __html: message.table,
                                  }}
                                  style={{
                                    width: "100%",
                                    height: "50vh",
                                    overflowY: "scroll",
                                    fontSize: "10px",
                                    color: "white",
                                  }}
                                />
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        )}
                        {pdfData && (
                          <Accordion className="meta-accordion">
                            <Accordion.Item eventKey="1">
                              <Accordion.Header>
                                <div className="accordion-title">Documents</div>
                                <div className="accordion-count">
                                  {message.pdfData?.source?.length}{" "}
                                  {/* Display the count */}
                                </div>
                                <CustomToggle eventKey="1" />
                              </Accordion.Header>
                              <Accordion.Body className="custom-accordion-body">
                                {message.pdfData?.source?.map((pdf, index) => (
                                  <button
                                    key={index}
                                    className="document-button"
                                    onClick={() =>
                                      handleButtonClick1(pdf.filepath)
                                    }
                                  >
                                    {pdf.filename}
                                  </button>
                                ))}
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        )}
                        <Accordion className="meta-accordion">
                          <Accordion.Item eventKey="2">
                            <Accordion.Header>
                              <div className="accordion-title">
                                Recommendations
                              </div>
                              <div className="accordion-count">
                                {message.recommendedQuestions?.length}{" "}
                                {/* Display the count */}
                              </div>
                              <CustomToggle eventKey="2" />
                            </Accordion.Header>
                            <Accordion.Body className="custom-accordion-body">
                              {message.recommendedQuestions?.map(
                                (question, index) => (
                                  <div
                                    key={index}
                                    className="recommendation-text"
                                  >
                                    {question.split("?").map((part, i) => (
                                      <span
                                        key={i}
                                        onClick={() => {
                                          handleQuestionSelect(part);
                                        }}
                                      >
                                        {part}
                                        {i === 0 ? "?" : ""}
                                        <br />
                                      </span>
                                    ))}
                                  </div>
                                )
                              )}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {loading ? <Loading /> : <></>}
              <div className="chat-input-container">
                <img src={mic} alt="Mic" className="mic-icon" />
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onPaste={handlePaste}
                  onKeyDown={handleKeyDown}
                  placeholder="What is in your mind?"
                  className="chat-textarea"
                />
                <label htmlFor="fileInput">
                  <img className="upload-icon" src={upload} alt="Upload" />
                </label>
                <input
                  id="fileInput"
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  accept=".pdf"
                  style={{ display: "none" }}
                />
                <img
                  src={send}
                  alt="Send"
                  onClick={handleSendButtonClick}
                  className="send-icon"
                />
              </div>
            </div>
            {/* )} */}
          </div>
        ) : loading ? (
          <Loading />
        ) : (
          <Library prelist={list} />
        )}
      </div>
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalImage && (
            <img src={modalImage} alt="Full Screen" style={{ width: "100%" }} />
          )}
        </Modal.Body>
      </Modal>
      <Modal show={showModal1} onHide={handleCloseModal1} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Table</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalImage1 && (
            <div
              className="tableStyle"
              dangerouslySetInnerHTML={{ __html: modalImage1 }}
              style={{
                maxHeight: "50vh",
                overflowY: "scroll",
                fontSize: "10px",
              }}
            />
          )}
        </Modal.Body>
      </Modal>
      {showPdfPopup && (
        <div
          className="popup-overlay"
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
        >
          <div
            className="popup-container"
            style={{ top: `${position.y}px`, left: `${position.x}px` }}
            onMouseDown={handleMouseDown}
          >
            <button className="close-button" onClick={handleClose}>
              &times;
            </button>
            <div className="top-part-chart-chatbot"></div>
            {!loading &&
              pdfData1 && ( // Add null check for pdfData1
                <div className="pdf-viewer">
                  <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                    <Viewer
                      fileUrl={pdfData1}
                      plugins={[newPlugin]}
                      scale={initialScale}
                    />
                  </Worker>
                </div>
              )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatScreen;
